import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=7a013728&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a013728')) {
      api.createRecord('7a013728', component.options)
    } else {
      api.reload('7a013728', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=7a013728&", function () {
      api.rerender('7a013728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eB1Y6V0rB0EZ/JS/comp/ErrorMessage.vue"
export default component.exports